import { useMutation } from "react-query";
import { post } from "shared/data";

export const useAddCustomSla = () => {
    return useMutation("addCustomSla", {
        mutationFn: (payload) => post("/sla/custom", payload),
    });
};
